import { useContext } from 'react';
import { ThemeContextType } from '../types';
import { ThemeContext } from '../context/Theme';

export const useTheme = () => {
    return useContext<ThemeContextType>(ThemeContext);
};
